import { PersonalIdentifierDocumentDto } from '@/shared/lib/sj-orm';
import { AssetDto } from '@/shared/lib/sj-orm/models/asset.dto';
import { BaseDto } from '@/shared/lib/sj-orm/models/base.dto';
import { ContactDto } from '@/shared/lib/sj-orm/models/contact.dto';
import { PrivateDocumentDto } from '@/shared/lib/sj-orm/models/document/private.document.dto';

import { SmartImportStore } from './stores/smartImport.store';

export type SmartImportDto = BaseDto & SmartImportStore;

export enum JobStatus {
  PENDING = 'pending',
  DONE = 'done',
}

export enum EntityType {
  ASSET = 'asset',
  CONTACT = 'contact',
  DOCUMENT = 'document',
}

export type EntitiesList = {
  assets: AssetDto[];
  privateDocuments: PrivateDocumentDto[];
  personalIdentifiers: PersonalIdentifierDocumentDto[];
  contacts: ContactDto[];
};

export type NonNullableFields<T> = {
  [K in keyof T as T[K] extends null | undefined ? never : K]: Exclude<T[K], null>;
};
